import React from "react";

import { FaqCategoryItem } from "../../types";
import styles from "../FaqCategoryItems.module.scss";

const Answer = () => (
  <div className={styles.answer}>
    <div className={styles.head}>
      <span className={styles.icon}>A</span>
      <p className={styles.text}>
        グループ分けは、先生が直接割り当てる仕様ではありません。
      </p>
    </div>
    <p className={styles.text}>
      先生は、教材の［グループ設定］からグループを作成します。
      <br />
      生徒は、生徒の教材画面メニュー［グループ］より、先生が作成したグループの中から自分で選択して所属します。
    </p>
  </div>
);

export const STUDENT_GROUP_WORK_FAQ: FaqCategoryItem = {
  id: "student-group-work-faq",
  question: "生徒にグループワークをさせたい",
  Answer,
};
